import API_PATH from '../../../config/API_PATH'
import { LOYALTY_POINT_HISTORY, LOYALTY_POINT_STATUS, LOYALTY_POINT_WITHDRAW } from './contants'

export const getLoyaltyPoint = data => {
	return {
		type: LOYALTY_POINT_STATUS,
		data,
		meta: {
			method: 'GET',
			url: API_PATH.loyaltyPoint,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}
export const getLoyaltyPointHistory = data => {
	return {
		type: LOYALTY_POINT_HISTORY,
		data,
		meta: {
			method: 'GET',
			url: API_PATH.loyaltyPointHistory,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}
export const postLoyaltyPointWithdraw = data => {
	return {
		type: LOYALTY_POINT_WITHDRAW,
		data,
		meta: {
			method: 'POST',
			url: API_PATH.loyaltyPointWithdraw,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}